import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ImportacaoPage } from '@/features/importacao-exportacao/page/ImportacaoPage';
import { IMPORTACAO_TIPOS } from '@/features/importacao-exportacao/types/ImportacaoTipo';
import { StringToIdpkSchema } from '@/std/schema';

const ParamsSchema = z.object({
    idpk: StringToIdpkSchema.optional(),
    tipo: z.enum(IMPORTACAO_TIPOS),
});

export const Route = createFileRoute('/a/importacao/$tipo/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const { idpk, tipo } = Route.useParams();

    return <ImportacaoPage idpk={idpk} tipo={tipo} />;
}
